// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".truck-summary-report .evan > .cell {\n  word-break: break-word;\n}", ""]);
// Exports
exports.locals = {
	"blacker": "#262626",
	"black": "#333333",
	"white": "#FFF",
	"red": "#DC3545",
	"orange": "#EB8D20",
	"yellow": "#F7D601",
	"green": "#14AF1B",
	"legacy-blue": "#A5D8FF",
	"bay-blue": "#2A3D92",
	"bay-blue-dark": "#2B3990",
	"bay-blue-darker": "#222E73",
	"neon-purple": "#8400FF",
	"navbar-height-no-unit": "56",
	"top-toolbar-height-no-unit": "56",
	"md-min": "768"
};
module.exports = exports;
